import apiClient, { unwrap } from './client'
import type { LlmProvider } from './types'

export const llmApi = {
  list() {
    return unwrap<LlmProvider[]>(apiClient.get('/llm/providers'))
  },
  create(data: Partial<LlmProvider>) {
    return unwrap<{ id: number }>(apiClient.post('/llm/providers', data))
  },
  update(id: number, data: Partial<LlmProvider>) {
    return unwrap<unknown>(apiClient.put(`/llm/providers/${id}`, data))
  },
  remove(id: number) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/llm/providers/${id}`))
  },
  /** 测试连通并拉取模型列表 */
  testConnection(data: { provider_type: string; base_url: string; api_key?: string }) {
    return unwrap<{ models: string[]; resolvedUrl?: string }>(
      apiClient.post('/llm/test-connection', data),
    )
  },
  /** 调用 LLM 生成邮件模板 */
  generate(data: {
    provider_id?: number
    model?: string
    prompt: string
    context?: {
      name?: string
      subject?: string
      body_html?: string
      body_text?: string
      variables?: unknown
    }
  }) {
    return unwrap<{ subject: string; body_html: string; body_text: string }>(
      apiClient.post('/llm/generate', data),
    )
  },
}